<app-metric-card
  class="col-4 mb-2"
  role="button"
  tabindex="0"
  [title]="'Average Compliance Rate'"
  [currentValue]="averageComplianceResponse().current_compliance_rate ?? 0"
  [previousValue]="averageComplianceResponse().previous_compliance_rate ?? 0"
  [valueChange]="averageComplianceResponse().percentage_difference ?? 0"
  [isHigherBetter]="true"
  [suffix]="'%'"
  (click)="onViewData()"
  (keydown.enter)="onViewData()"
></app-metric-card>

@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>{{ modalTitle() }}</kendo-dialog-titlebar>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable
          [data-href]="url"
          [columns]="datatableColumns"
          [useOData]="true"
          [initialFilters]="periodParams()"
        ></app-datatable>
      </div>
    }
  </kendo-dialog>
}
